module.exports = __webpack_public_path__ + "img/proyecto_11.75998f32.webp";